import BaseModel from '../core/BaseModel'
import {constants} from "../services/constants";
//import moment from "moment";
//import {constants}  from '../services/constants'
//import moment from "moment-timezone";
export default class ReportServiceSuppliesModel extends BaseModel {
    constructor() {
        super({ 
                name: "report_service_supplies",
                tableName: 'core_warranty_repair_product_sn_has_service_supplies'
            }, 
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID',
                primaryKey: true,
                display: false,
            },
            modified_date_text: {
                name: 'modified_date_text',
                type: "Date",
                label: 'Ngày cập nhật',
                width: 13,
                sortable: false,
                computed: (data) => {
                    var data_date = null;
                    if (!constants.isEmpty(data.modified_date)){
                        data_date = data.modified_date;
                    }
                    data.modified_date_text = data_date;
                }
            },
            code_text: {
                    name: 'code_text',
                    type: "String",
                    label: 'Mã vật tư - dịch vụ',
                    width: 13,
                    sortable: false,
                    computed: (data) => {
                        var text_data = "";
                        if (!constants.isEmpty(data.obj_service_supplies)){
                            text_data = (!constants.isEmpty(data.obj_service_supplies.code)) ? data.obj_service_supplies.code:'';
                        }
                        data.code_text = text_data;
                    }
                },
                name_text: {
                    name: 'name_text',
                    type: "String",
                    label: 'Tên vật tư - dịch vụ',
                    width: 13,
                    sortable: false,
                    computed: (data) => {
                        var text_data = "";
                        if (!constants.isEmpty(data.obj_service_supplies)){
                            text_data = (!constants.isEmpty(data.obj_service_supplies.name)) ? data.obj_service_supplies.name:'';
                        }
                        data.name_text = text_data;
                    }
                },
                unit_service_text: {
                    name: 'unit_service_text',
                    type: "String",
                    label: 'Đơn vị tính',
                    width: 13,
                    sortable: false,
                    computed: (data) => {
                        var text_data = "";
                        if (!constants.isEmpty(data.unit_text)){
                            text_data = data.unit_text;
                        }
                        data.unit_service_text = text_data;
                    }
                },
                number_text: {
                    name: 'number_text',
                    type: "String",
                    label: 'Số lượng',
                    width: 13,
                    sortable: false,
                    computed: (data) => {
                        var text_data = "";
                        if (!constants.isEmpty(data.number)){
                            text_data = data.number;
                        }
                        data.number_text = text_data;
                    }
                },
                organization_text: {
                    name: 'organization_text',
                    type: "String",
                    label: 'Đơn vị thực hiện',
                    width: 13,
                    sortable: false,
                    computed: (data) => {
                        var text_data = "";
                        if (!constants.isEmpty(data.obj_modified_organization)){
                            text_data = (!constants.isEmpty(data.obj_modified_organization.name)) ? data.obj_modified_organization.name:'' ;
                        }
                        data.organization_text = text_data;
                    }
                },
            fied_detail: {
                refs: '  id number modified_date obj_service_supplies { code id name unit unit_price } obj_modified_organization { id name }  ',
                display: false
            }
        },)
    }

}